
<template>
  <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline"  label-width="100px" size="mini">
        <div class="formItemBox">
          <el-form-item label="货物类型:" class="">
            <el-select v-model="searchFrom.productTypeName" filterable placeholder="请选择" style="width:150px">
              <el-option label="全部" value="" ></el-option>
              <el-option v-for="item in HWlist" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
           <el-form-item label="能源类型:" class="">
            <el-select v-model="searchFrom.energyTypeName" filterable placeholder="请选择" style="width:150px">
              <el-option label="全部" value="" ></el-option>
              <el-option v-for="item in NYtype" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="目的流向:" class="">
            <el-input maxlength="" v-model.trim="searchFrom.endDirection" style="width:180px;"></el-input>
          </el-form-item>
          <el-form-item label="更新时间:" class="item2" >
            <el-date-picker
                v-model="searchFrom.updateTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item>
        </div>
        <div style="display: flex;justify-content: space-between;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox">
            <el-button type="primary" size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary" size="mini" @click="resetForm('searchFrom')">重置</el-button>
            <el-button type="primary" size="mini" @click="addFn">新增</el-button>
            <el-button type="primary" size="mini" @click="delFn">删除</el-button>
            <el-button type="primary" size="mini" @click="editFn">修改</el-button>
            <!-- <el-button type="primary" @click="THimportFn()">导入</el-button> -->
            <!-- <el-button type="primary" @click="THimportFn()">导出</el-button> -->
          </div>
        </div>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{height:h}">
      <el-table :data="tableList" ref="tableRef" v-loading="loading" bordersize="mini" @selection-change="selectGoods" @row-click="handleRowClick"
      class="tableComent" height="100%" style="width:100%" center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <div>
             <el-button type="text" size="mini" @click="fuzhiFn(scope.row)">复制</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="payee" label="结算客户" min-width="260" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="productTypeName" label="货物类型" width="120" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="startDirection" label="始发流向" width="400" :formatter="formatterRowEmpty" show-overflow-tooltip></el-table-column>
        <el-table-column prop="endDirection" label="目的流向" width="400"  show-overflow-tooltip></el-table-column>
        <el-table-column prop="arriveDepartFlag" label="是否往返" width="" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="needLength" label="车长" width="" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="energyTypeName" label="能源类型" width="" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="freightPricingTypeName" label="运费计价" width="" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="price" label="运费(元)" width="140" :formatter="formatterRowEmpty"></el-table-column>
        <!-- <el-table-column prop="disburseSurcharge" label="支出附加(元)" width="140" :formatter="formatterRowEmpty"></el-table-column> -->
        <el-table-column prop="updateUser" label="更新人" width="120"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" width="170" :formatter="dateTimeFormat"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170" :formatter="dateTimeFormat"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
     <el-dialog  :title="isAdd?'新建':'修改'" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"
    :visible.sync="dialogVisible" width="80%" center >
      <div>
        <el-form :inline="true" ref="addFrom"  :model="addFrom" :rules="rules"  class="demo-form-inline jiaoyan" size="mini">
         <el-table :data="addFrom.goodsList"  ref="table"   bordersize="mini"  style="width: 100%" max-height="500px"  center border v-if="dialogVisible">
          <el-table-column label="操作"  width="100" v-if="isAdd">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini" @click="addGoodFn(scope.row)">复制</el-button>
                <el-button type="text" size="mini" @click="delGoodFn(scope.$index)">删除</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column type="index"  label="序号" width="60"></el-table-column>
          <el-table-column label="结算客户" min-width="180">
            <template slot="header" ><div><span class="red">*</span>结算客户</div></template>
            <template slot-scope="scope">
              <div>
              <el-form-item label="" :prop="'goodsList.' +scope.$index+ '.payee'" :key="scope.$index"   class="table_error" :rules="rules.payee"  >
                <el-select  v-model="addFrom.goodsList[scope.$index].payee" filterable placeholder="请选择" clearable   @change="payeeChange($event,scope.row)">
                  <el-option v-for="item in kehuList" :label="item.customerName" :value="item.customerName" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="货物类型" min-width="120">
            <template slot="header" ><div><span class="red">*</span>货物类型</div></template>
            <template slot-scope="scope">
              <div>
                <el-form-item label="" :prop="'goodsList.' +scope.$index+ '.productTypeName'" :key="scope.$index"   class="table_error" :rules="rules.productTypeName"  >
                  <el-select  v-model="addFrom.goodsList[scope.$index].productTypeName" filterable placeholder="请选择" clearable   @change="productTypeNameChange($event,scope.row)">
                    <el-option v-for="item in HWlist" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="始发流向" min-width="320">
            <template slot="header" ><div><span class="red">*</span>始发流向</div></template>
            <template slot-scope="scope">
              <div>
                <el-form-item label="" :prop="'goodsList.' +scope.$index+ '.deliverProvinceName'" :key="scope.$index" :rules="rules.deliverProvinceName" class="table_error">
                  <div style="display: flex;">
                  <shengShiXian v-if="dialogVisible" :rowData="{id:true,provinceCode:scope.row.deliverProvinceCode,
                  cityCode:scope.row.deliverCityCode,areaCode:scope.row.deliverAreaCode
                  }" @handleChange="handleChange($event,scope.$index)"
                    ref="reference"></shengShiXian>
                  <el-input v-model="addFrom.goodsList[scope.$index].deliverRemark" autocomplete="off" maxlength="50" style="width: 100px"
                  size="mini"></el-input>
                  </div>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="目的流向" min-width="320">
            <template slot="header" ><div><span class="red">*</span>目的流向</div></template>
            <template slot-scope="scope">
              <div>
                <el-form-item label="" :prop="'goodsList.' +scope.$index+ '.receivingProvinceName'" :key="scope.$index" :rules="rules.receivingProvinceName" class="table_error">
                  <div style="display: flex;">
                  <shengShiXian v-if="dialogVisible" :rowData="{id:true,provinceCode:scope.row.receivingProvinceCode,
                  cityCode:scope.row.receivingCityCode,areaCode:scope.row.receivingAreaCode
                  }" @handleChange="handleChangeMD($event,scope.$index)"
                    ref="reference"></shengShiXian>
                  <el-input v-model="addFrom.goodsList[scope.$index].receivingRemark" autocomplete="off" maxlength="50" style="width: 100px"
                  size="mini"></el-input>
                  </div>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="是否往返" min-width="130">
            <template slot-scope="scope">
              <div>
                <el-form-item label="" :prop="'goodsList.' +scope.$index+ '.arriveDepartFlag'" :key="scope.$index"   class="table_error"   >
                  <el-radio-group v-model="addFrom.goodsList[scope.$index].arriveDepartFlag"   >
                    <el-radio label="是">是</el-radio>
                    <el-radio label="否">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="车长" min-width="100">
            <template slot-scope="scope">
              <div>
                <el-form-item label="" :prop="'goodsList.' +scope.$index+ '.needLength'" :key="scope.$index"   class="table_error"   >
                  <el-select  v-model="addFrom.goodsList[scope.$index].needLength" filterable placeholder="请选择" clearable  >
                    <template  v-for="item in CClist">
                    <el-option :label="item.name" v-if="item.name=='全部'" :value="item.name" :key="item.id"></el-option>
                    <el-option :label="item.name+'米'" v-else :value="item.name+'米'" :key="item.id"></el-option>
                    </template>
                  </el-select>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="能源类型" min-width="120">
            <template slot="header" ><div><span class="red">*</span>能源类型</div></template>
            <template slot-scope="scope">
              <div>
                <el-form-item label="" :prop="'goodsList.' +scope.$index+ '.energyTypeName'" :key="scope.$index"   class="table_error" :rules="rules.productTypeName"  >
                  <el-select  v-model="addFrom.goodsList[scope.$index].energyTypeName" filterable placeholder="请选择" clearable   @change="energyTypeNameChange($event,scope.row)">
                    <el-option v-for="item in NYtype" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="运费计价" min-width="100">
            <template slot="header" ><div><span class="red">*</span>结算计价</div></template>
            <template slot-scope="scope">
              <div>
                <el-form-item label="" :prop="'goodsList.' +scope.$index+ '.freightPricingTypeName'" :key="scope.$index"   class="table_error" :rules="rules.freightPricingTypeName"  >
                  <el-select  v-model="addFrom.goodsList[scope.$index].freightPricingTypeName" filterable placeholder="请选择" clearable   @change="JSJJChange($event,scope.row)">
                    <el-option v-for="item in SRJJlist" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="运费(元)" min-width="120">
            <template slot="header" ><div><span class="red">*</span>运费(元)</div></template>
            <template slot-scope="scope">
              <div>
                <el-form-item label="" :prop="'goodsList.' +scope.$index+ '.price'" :key="scope.$index" :rules="rules.price" class="table_error">
                  <el-input placeholder="" maxlength="20" v-number-input.float="2"
                    v-model.trim="addFrom.goodsList[scope.$index].price" ></el-input>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="支出附加(元)" min-width="120">
            <template slot="header" ><div><span class="red">*</span>支出附加(元)</div></template>
            <template slot-scope="scope">
              <div>
                <el-form-item label="" :prop="'goodsList.' +scope.$index+ '.disburseSurcharge'" :key="scope.$index" :rules="rules.disburseSurcharge" class="table_error">
                  <el-input placeholder="" maxlength="20"
                    v-model.trim="addFrom.goodsList[scope.$index].disburseSurcharge" ></el-input>
                </el-form-item>
              </div>
            </template>
          </el-table-column> -->
         </el-table>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFN" :loading="loading">提交</el-button>
      </span>
    </el-dialog>
    <!-- 导入 -->
    <importC v-if="importDialog" @DRsave="DRsave" @destroy="destroy"></importC>
  </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { getDictionaryDetailList, importShougangPrice, findPriceVehicleLists, addPriceVehicle,
  updatePriceVehicle, deletePriceVehicle, findCustomerInfoList } from '@/api/newTMS'
import { formatterRowEmpty, dateTimeFormat, dateFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import shengShiXian from '@/components/common/shengShiXian.vue'
import { cVLlist } from '@/api/vgs-driver2.0'
export default {
  components: {
    shengShiXian
  },
  data () {
    return {
      exportMark: false,
      formatterRowEmpty: formatterRowEmpty,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      h: 500,
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      tableList: [],
      total: 0,
      loading: false,
      rules: {
        payee: [
          { required: true, message: '请选择结算客户', trigger: 'blur' }
        ],
        productTypeName: [
          { required: true, message: '请选择货物类型', trigger: 'blur' }
        ],
        deliverProvinceName: [
          { required: true, message: '请选择始发流向', trigger: 'blur' }
        ],
        receivingProvinceName: [
          { required: true, message: '请选择目的流向', trigger: 'blur' }
        ],
        energyTypeName: [
          { required: true, message: '请选择能源类型', trigger: 'blur' }
        ],
        freightPricingTypeName: [
          { required: true, message: '请选择结算计价', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入收入价格', trigger: 'blur' }
        ]
      },
      btnFlg: [],
      btnIdArr: ['01N0010100', '01N0010200'],
      isDisable: false,
      importDialog: false,
      HWlist: [],
      NYtype: [
        { itemNo: 0, showName: '******' },
        { itemNo: -1, showName: '其他' },
        { itemNo: 1, showName: '汽油' },
        { itemNo: 2, showName: '柴油' },
        { itemNo: 3, showName: '天然气' },
        { itemNo: 4, showName: '电' }
      ],
      SRJJlist: [],
      isAdd: false,
      addFrom: { goodsList: [] },
      dialogVisible: false,
      kehuList: []
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/shouGangPrice')
    this.getList(this.searchFrom)
    getDictionaryDetailList({ dictionaryType: 'goods_type' }).then(res => { this.HWlist = res })
    cVLlist().then(res => {
      this.CClist = res
      this.CClist.unshift({
        name: '全部'
      })
    })
    findCustomerInfoList({ businessType: 1 }).then(res => { this.kehuList = res })
    getDictionaryDetailList({ dictionaryType: 'settlement_pricing' }).then(res => {
      this.SRJJlist = res
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight // 头部搜索盒子高度
    let pH = document.documentElement.clientHeight // 浏览器高度
    this.h = pH - h - 166 + 'px'
    // 218 ->页面除盒子外的高度
  },
  methods: {
    // 客户改变
    payeeChange (e, row) {
      if (e) {
        let json = this.kehuList.filter(item => item.customerName == e)
        row.payeeTaxId = json[0].customerTaxId
      } else {
        this.$set(row, 'payee', null)
        this.$set(row, 'payeeTaxId', null)
      }
    },
    // 列表复制
    fuzhiFn (row) {
      delete row.id
      let json = { ...row }
      this.addFrom.goodsList = []
      this.addFrom.goodsList.push(json)
      this.dialogVisible = true
      this.isAdd = true
    },
    // 复制
    addGoodFn (row) {
      let json = { ...row }
      this.addFrom.goodsList.push(json)
    },
    // 弹框删除货物
    delGoodFn (index) {
      if (this.addFrom.goodsList.length == 1) {
        this.$alert('最后一条数据不可以删除', '系统提示')
        return
      }
      this.addFrom.goodsList.splice(index, 1)
    },
    // 能源类型
    energyTypeNameChange (e, row) {
      if (e) {
        let json = this.NYtype.filter(item => item.showName == e)
        row.energyType = json[0].itemNo
      } else {
        this.$set(row, 'energyTypeName', null)
        this.$set(row, 'energyType', null)
      }
    },
    // 货物类型改变
    productTypeNameChange (e, row) {
      if (e) {
        let json = this.HWlist.filter(item => item.showName == e)
        row.productType = json[0].itemNo
      } else {
        this.$set(row, 'productTypeName', null)
        this.$set(row, 'productType', null)
      }
    },
    // 始发流向
    handleChange (value, index) {
      if (value) {
        this.addFrom.goodsList[index].deliverProvinceCode = value[0].areaCode
        this.addFrom.goodsList[index].deliverCityCode = value[1].areaCode
        this.addFrom.goodsList[index].deliverAreaCode = value[2].areaCode
        this.$set(this.addFrom.goodsList[index], 'deliverProvinceName', value[0].name)
        this.addFrom.goodsList[index].deliverCityName = value[1].name
        this.addFrom.goodsList[index].deliverAreaName = value[2].name
      }
    },
    // 目的流向
    handleChangeMD (value, index) {
      if (value) {
        this.addFrom.goodsList[index].receivingProvinceCode = value[0].areaCode
        this.addFrom.goodsList[index].receivingCityCode = value[1].areaCode
        this.addFrom.goodsList[index].receivingAreaCode = value[2].areaCode
        this.$set(this.addFrom.goodsList[index], 'receivingProvinceName', value[0].name)
        this.addFrom.goodsList[index].receivingCityName = value[1].name
        this.addFrom.goodsList[index].receivingAreaName = value[2].name
      }
    },
    // 结算计价改变
    JSJJChange (e, row) {
      if (e) {
        let json = this.SRJJlist.filter(item => item.showName == e)
        row.freightPricingType = json[0].itemNo
      } else {
        this.$set(row, 'freightPricingTypeName', null)
        this.$set(row, 'freightPricingType', null)
      }
    },
    // 新增
    addFn () {
      this.addFrom.goodsList = [{ disburseSurcharge: 0 }]
      this.dialogVisible = true
      this.isAdd = true
    },
    // 修改
    editFn () {
      let selectData = this.$refs.tableRef.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      this.addFrom.goodsList = selectData
      this.dialogVisible = true
      this.isAdd = false
    },
    saveFN () {
      let that = this
      this.loading = true
      let newArr = []
      this.addFrom.goodsList.forEach(item => {
        if (item.deliverRemark) {
          item.startDirection = item.deliverProvinceName + '-' + item.deliverCityName + '-' + item.deliverAreaName + '-' + item.deliverRemark
        } else {
          item.startDirection = item.deliverProvinceName + '-' + item.deliverCityName + '-' + item.deliverAreaName
        }
        if (item.receivingRemark) {
          item.endDirection = item.receivingProvinceName + '-' + item.receivingCityName + '-' + item.receivingAreaName + '-' + item.receivingRemark
        } else {
          item.endDirection = item.receivingProvinceName + '-' + item.receivingCityName + '-' + item.receivingAreaName
        }

        let json = {
          productTypeName: item.productTypeName,
          startDirection: item.startDirection,
          endDirection: item.endDirection,
          energyTypeName: item.energyTypeName,
          freightPricingTypeName: item.freightPricingTypeName
        }
        newArr.push(JSON.stringify(json))
      })
      if (new Set(newArr).size !== newArr.length) {
        this.$alert('不能有重复的数据', '系统提示')
        this.loading = false
        return
      }
      this.$refs.addFrom.validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            addPriceVehicle(this.addFrom.goodsList).then(res => {
              loading.close()
              this.getList(this.searchFrom)
              this.loading = false
              this.dialogVisible = false
              this.$message({
                message: '操作成功',
                type: 'success'
              })
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  that.loading = false
                  loading.close()
                }
              })
            })
          } else {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            updatePriceVehicle(this.addFrom.goodsList).then(res => {
              loading.close()
              this.getList(this.searchFrom)
              this.loading = false
              this.dialogVisible = false
              this.$message({
                message: '操作成功',
                type: 'success'
              })
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                  that.loading = false
                }
              })
            })
          }
        } else {
          this.loading = false
        }
      })
    },
    // 删除
    delFn () {
      let selectData = this.$refs.tableRef.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        deletePriceVehicle({ ids: selectData.map(item => item.id) }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    exportList (val) {
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      form.header = val
      exportExcel(
        this.global.tmsPlus + '/order/exportOrderList',
        form,
        '订单列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 导出
    exportFn () {
      this.exportMark = true
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.tableRef.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      findPriceVehicleLists(searchFrom).then((res) => {
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    // 导入
    THimportFn () {
      this.importDialog = true
    },
    destroy () {
      this.importDialog = false
    },
    DRsave (formData) {
      // formData.append('MultipartFile', 'excl')
      let form = {
        priceDate: this.searchFrom.priceDate
      }
      formData.append('params', JSON.stringify(form))
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      importShougangPrice(formData).then(res => {
        loading.close()
        this.importDialog = false
        var that = this
        console.log(res, 'res')
        this.msg = this.$message({
          showClose: false,
          message: '导入成功',
          type: 'success',
          onClose () {}
        })
        this.getList(this.searchFrom)
      }).catch(error => {
        this.msg = this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    closeDialog () {

    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox{
  margin: 10px 0;
}
.inpBox .el-date-editor{
  width: 420px!important;
}
/deep/.el-form{
  width: 100%;
}
.box{
  width: 100%;
   display: grid;
   grid-template-columns: repeat(auto-fill, 270px);
   grid-auto-flow: row dense;
   /deep/.el-textarea__inner{
    width: 150px;
    height: 68px;
   }
   .item1{
      grid-row-start: span 2;
    }
   .item2{
      grid-column-start: span 2;
      //width: 540px;
   }
}
/deep/.jiaoyan .el-form-item--mini.table_error {
  margin-bottom: 0 !important;
  margin: 14px 0 !important;
}
</style>
